import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className={props.className}>
    <g fill="none" fillRule="evenodd" stroke="#B5B4B8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(1 1)">
      <path d="M4.5 5.5v10" />
      <circle cx="3" cy="2" r="1.5" />
      <path d="M9.5 5.5h-8a1 1 0 0 0-1 1v9" />
      <path d="M7.5 2.5h8v9h-8M10.5 11.5l2 4M9.5.5v2" />
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
